const initialState = {
	list: [],
	datetime: null,
};

export default function reducer(state = initialState, action) {
	if (action.type === 'NEWS_LIST_SET') {
		let newState = Object.assign({}, state);
    newState.list = action.payload.list;
		newState.datetime = (new Date());
		return newState;
	}
	else {
		return state;
	}
}
